import { FC } from "react"
import Color from "../../constants/Color"
import CascadeText from "./CascadeText"

// These numbers seem to give the best results for having the same amount of space around the text on each side.
// There's probably a better way to calculate them. The problem I have is that the text is all upper case and so should be
// positioned according to the distance between the baseline and the cap height, rather than the font size.
// There is an extra space at the end of the text due to the letter spacing, which needs to be truncated by the limiting the width of the text element.
// BC, 22 Oct 2024
const textHeight = 40
const fontSize = (textHeight + 15)
const viewPortHeight = (textHeight + 1)
const viewPortWidth = 740

interface Props extends React.SVGProps<SVGSVGElement> {
    widthInPx: number
    tween: number
}

const Logo: FC<Props> = ({ widthInPx, tween }) => {

    const fadeDuration = 0.4

    return <svg viewBox={`0 0 ${viewPortWidth} ${viewPortHeight}`} width={widthInPx + "px"}>
        <defs>
            <linearGradient id="gradient" x1="0" x2="1" y1="0" y2="0">
                <stop offset="0%" stopColor={Color.Coral} stopOpacity="1"/>
                <stop offset="20%" stopColor={Color.White} stopOpacity="1"/>
                <stop offset="60%" stopColor={Color.Gold} stopOpacity="1"/>
                <stop offset="100%" stopColor={Color.Coral} stopOpacity="1"/>
            </linearGradient>
        </defs>
        
        <CascadeText text="COPERNICAEUM"
                     tween={tween}
                     fadeDuration={fadeDuration}
                     x="0"
                     y={textHeight}
                     width={viewPortWidth}
                     fontSize={fontSize}
                     letterSpacing={fontSize / 2}
                     fill="url(#gradient)" />
    </svg>
}

export default Logo